module.exports = __webpack_public_path__ + "img/Rogue-troll-m-70.cfe13825.gif";